export default (idPermission, idClub) => {
    if (idPermission === "dfc82482-8cb2-11de-a173-001372568c9a")// si l'idPermission et du CA, il a d'office accès au club 
        return true;

    if (idPermission === idClub)// si la permission correspond au club recherché
        return true;

    //Je sais utiliser window pour des variables globales c'est pas bien mais je n'avais que ça 
    return window.clubtree?.filter(e => e.parent === idPermission && e.child === idClub).length > 0;
}